import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './ConfirmButton.styles';

function ConfirmButton({ onConfirm, isConfirmDisabled }) {
  const theme = useTheme() || LightThemeColors;

  return (
    <View style={styles.buttonContainer(theme)}>
      <VFButton
        type="primary"
        title="personal_preferences_confirm_button"
        onPress={onConfirm}
        disabled={isConfirmDisabled}
        disabledStyle={styles.disabledButtonStyle(theme)}
        disabledTextStyle={styles.disabledTextStyle(theme)}
      />
    </View>
  );
}

ConfirmButton.propTypes = {
  isConfirmDisabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmButton;
